































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
  name: 'exporo-modal',
})
export default class Modal extends Vue {
  @Prop({ required: true }) private active!: Boolean;
  @Prop({ required: true }) private name!: String;
  @Prop({ default: null }) private onClose: Function;

  @Watch('active')
  onPropertyChanged(value: boolean, oldValue: boolean, deep: true) {
    if (!value) {
      document.getElementById('app').className = '';
    } else {
      document.getElementById('app').className = 'no-overflow';
    }
  }
}
